import $ from 'jquery';
import buttonUp from './buttonUp';

(function ($) {
	$(function () {
		var submitIcon = $('.searchbar-icon');
		var isOpen = false;
		var searchbar = $('.searchbar');
		var inputBox = $('.searchbar-input');

		submitIcon.each(function () {
			$(this).on('click', function (e) {
				searchbar = $(this).closest('.searchbar');
				inputBox = searchbar.find('.searchbar-input');

				if (!isOpen) {
					searchbar.addClass('searchbar-open');
					inputBox.focus();
					isOpen = true;
				} else {
					searchbar.removeClass('searchbar-open');
					// inputBox.blur();
					isOpen = false;
				}
			});
		});
		// submitIcon.on('click', function (e) {
		// 	if (!isOpen) {
		// 		searchbar.addClass('searchbar-open');
		// 		inputBox.focus();
		// 		isOpen = true;
		// 	} else {
		// 		searchbar.removeClass('searchbar-open');
		// 		inputBox.blur();
		// 		isOpen = false;
		// 	}
		// 	return false;
		// });

		$(document).on('click', function (event) {
			if (!$(event.target).closest('.searchbar').length && isOpen) {
				searchbar.removeClass('searchbar-open');
				// inputBox.blur();
				isOpen = false;
			}
		});

		// inputBox.on('keyup', buttonUp);
	});
})(jQuery);
